<template>
    <vue-perfect-scrollbar
        :class="scrollbarClasses"
        :settings="perfectScrollbarOptions"
        ref="scrollbar">
        <div
            @dragstart.capture="onDragStart"
            @click.capture="onClick"
            @mousedown="onMouseDown">
            <slot></slot>
        </div>
    </vue-perfect-scrollbar>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';

    export default {
        name: 'scroll-area',

        components: {
            VuePerfectScrollbar,
        },

        props: {
            showScrollbar: {
                type: Boolean,
                default: true,
            },

            // If enabled, can drag on the container to scroll.
            dragScrollEnabled: {
                type: Boolean,
                default: false,
            },

            // If enabled, scrolling past the end of the container will try to
            // propagate the scroll to the parent element (likely the page).
            wheelPropagationEnabled: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {
                dragging: false,
                dragStartX: null,
                dragStartY: null,
                dragStartTop: null,
                dragStartLeft: null,
                captureThreshold: 1,
                captureClick: false,
            };
        },

        mounted() {
            document.addEventListener('mouseup', this.onMouseUp);
            document.addEventListener('mousemove', this.onMouseMove);
        },

        beforeDestroy() {
            document.removeEventListener('mouseup', this.onMouseUp);
            document.removeEventListener('mousemove', this.onMouseMove);
        },

        methods: {
            onDragStart(ev) {
                if (this.dragScrollEnabled) {
                    ev.preventDefault();
                }
            },
            onClick(ev) {
                if (this.dragScrollEnabled && this.captureClick) {
                    ev.preventDefault();
                }
            },
            onMouseDown(ev) {
                if (this.dragScrollEnabled) {
                    ev.preventDefault();
                    this.dragging = true;
                    this.dragStartX = ev.clientX;
                    this.dragStartY = ev.clientY;
                    this.dragStartTop = this.getScrollTop();
                    this.dragStartLeft = this.getScrollLeft();
                    this.captureClick = false;
                }
            },
            onMouseUp(ev) {
                if (this.dragScrollEnabled) {
                    this.dragging = false;
                }
            },
            onMouseMove(ev) {
                if (this.dragScrollEnabled && this.dragging) {
                    ev.preventDefault();
                    const diffX = ev.clientX - this.dragStartX;
                    const diffY = ev.clientY - this.dragStartY;
                    const scrollTop = this.dragStartTop + (-diffY);
                    const scrollLeft = this.dragStartLeft + (-diffX);
                    this.setScrollTop(scrollTop);
                    this.setScrollLeft(scrollLeft);

                    if (Math.abs(diffX) >= this.captureThreshold ||
                        Math.abs(diffY) >= this.captureThreshold) {
                        this.captureClick = true;
                    }
                }
            },

            update() {
                this.$refs.scrollbar.update();
            },

            getScrollLeft() {
                return this.$refs.scrollbar.$el.scrollLeft;
            },

            getScrollTop() {
                return this.$refs.scrollbar.$el.scrollTop;
            },

            setScrollLeft(scrollLeft) {
                this.$refs.scrollbar.$el.scrollLeft = scrollLeft;
            },

            setScrollTop(scrollTop) {
                this.$refs.scrollbar.$el.scrollTop = scrollTop;
            },
        },

        computed: {
            scrollbarClasses() {
                return {
                    'scroll-area': true,
                    'hide-scrollbars': !this.showScrollbar,
                };
            },

            perfectScrollbarOptions() {
                return {
                    wheelPropagation: this.wheelPropagationEnabled,
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    .scroll-area {
        position: relative;
        width: 100%;
        overflow: hidden;
        height:100%!important;
    }
</style>

<style lang="scss">
    .scroll-area {
        .ps__scrollbar-x-rail,
        .ps__scrollbar-y-rail {
            background: #333 !important;
            opacity: 1 !important;
        }
        .ps__scrollbar-x-rail {
            height: 10px !important;
        }
        .ps__scrollbar-y-rail {
            width: 10px !important;
        }
        .ps__scrollbar-x,
        .ps__scrollbar-y {
            background: #1a1a1a !important;
            border-radius: 0 !important;
        }
        .ps__scrollbar-x {
            bottom: 0 !important;
            height: 10px !important;
        }
        .ps__scrollbar-y {
            right: 0 !important;
            width: 10px !important;
        }
    }

    .scroll-area.hide-scrollbars {
        .ps__scrollbar-x-rail,
        .ps__scrollbar-y-rail {
            visibility: hidden;
        }
    }
</style>



// WEBPACK FOOTER //
// index.vue?5bd2efab